import { render, staticRenderFns } from "./le-input-price.vue?vue&type=template&id=61b109af&"
import script from "./le-input-price.vue?vue&type=script&lang=js&"
export * from "./le-input-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports